import { hasAuthorization } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { deleteAllFavorites as generatedDeleteAllFavorites } from '@generated/search-bff/controllers/favorites/favorites';

/**
 * Delete all favorites for an account.
 * Requires a valid JWT token in the `apiConfig`.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/favorites/deleteAllFavorites Search API Documentation}
 */
export async function deleteAllFavorites(apiConfig: ApiConfig): Promise<ApiResult<void>> {
  if (!hasAuthorization(apiConfig)) {
    console.warn(
      'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
    );
  }

  try {
    const response = await generatedDeleteAllFavorites(apiConfig);
    return {
      status: 'success',
      data: response,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
